export default "__VITE_ASSET__B9m6KKOM__"